<script>
import SpeakerCard from './speaker-card.vue'
import SpeakerNavbar from './speaker-navbar.vue'

export default {
  components: {SpeakerCard, SpeakerNavbar},
  props: ['eventShortName'],

  data() {
    return {
      filter: {},
      speakers: [],
      numSpeakers: 0,
      numPages: 0,
      numFavorites: 0,
      page: this.$route.query.page || 1,
    }
  },

  computed: {
    favoriteMode() { return this.eventShortName == undefined || !navigator.onLine }
  },

  watch: {
    filter: {
      handler(newValue) {
        this.page = 1
        this.fetchSpeakers(newValue)
        let query = this.filter.search ? {search: this.filter.search} : {}
        if (this.filter.favorites)
          query.favorites = "1"
        this.pushQuery(query)
      },
      deep: true
    },
    page: {
      handler(newValue) {
        this.fetchSpeakers({page: newValue, ...this.filter})
      },
    },
  },

  created() {
    this.getFavorites()
    if (this.$route.query.search) {
      this.filter.search = this.$route.query.search
    }
    if (this.$route.query.favorites) {
      this.filter.favorites = "1"
    } else if (this.favoriteMode) {
      this.filter.favorites = "1"
    }
    this.fetchSpeakers({page: this.page, ...this.filter})
  },

  methods: {
    pushQuery(query) {
      try {
        this.$router.push({query: query})
      } catch(error) {
        console.error(error)
      }
    },

    getFavorites() {
      let favorites = this.$storage.getItem('favorite_speaker', [])
      this.numFavorites = favorites.length
      return favorites
    },

    onSearchChanged: function (search) {
        if (search)
          this.$set(this.filter, 'search', search)
        else
          this.$delete(this.filter, 'search')
    },

    parseDate: function (datetimeStr, locale = 'de') {
      const opts = {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: 'Europe/Berlin',
      }
      return new Date(datetimeStr).toLocaleString(locale, opts)
    },

    toggleFavorites(onOff) {
      if (onOff) {
        this.$set(this.filter, 'favorites', "1")
      } else {
        this.$delete(this.filter, 'favorites')
      }

    },

    fetchSpeakers: function (filter) {
      let me =  this
      let params = {...filter}
      let payload = {}
      if (this.favoriteMode) {
        if (this.getFavorites().length < 1) {
          this.speakers = []
          this.numSpeakers = 0
          this.numPages = 1
          return
        }
      } else {
        params.event_short_name = this.eventShortName
        if (params.favorites) {
          delete params.favorites
          payload.content_code = this.getFavorites()
        }
      }
      if (navigator.onLine)
        this.$api.post('/speakers/', payload, {params: params,}).then(function(response){
          me.speakers = response.data.results
          me.numPages = response.data.pages
          me.numSpeakers = response.data.count
        })
      else {
        me.speakers = Object.values(this.$storage.getItem('speakers', {}))
        me.numSpeakers = me.speakers.length
        me.numPages = 1
      }
    },

    previousPage: function() {
      if (this.page > 1) this.page--
      let query = this.filter
      if (this.page > 1) query.page = this.page
      this.$router.push({query: query})
    },

    nextPage: function() {
      if (this.page < this.numPages) this.page++
      let query = this.filter
      if (this.page > 1) query.page = this.page
      this.$router.push({query: query})
    },
  },
}
</script>

<template>

  <div>
    <speaker-navbar class="mb-1"
      :filter="filter"
      fav-key="content_code"
      :fav-mode="favoriteMode"
      @search="onSearchChanged($event)" 
      @delete-search="onSearchChanged($event)" 
      @toggle-favorites="toggleFavorites($event)" 
    />

    <div v-if="numSpeakers > 0">
      <small class="text-muted me-1">{{numFavorites}} Favoriten / {{numSpeakers}} Treffer</small>

      <div class="d-flex flex-wrap justify-content-between align-items-stretch mt-1">
        <speaker-card v-for="speaker in speakers" :key="speaker.id" :speaker="speaker" 
         @favorite-changed="getFavorites" />
      </div>

      <div class="py-3 text-center">
        <button :disabled="page == 1">
          <i class="fas fa-chevron-left" @click.prevent="previousPage()"></i>
        </button>
        <span class="mx-3">{{ page }} / {{ numPages }}</span>
        <button :disabled="page == numPages">
          <i class="fas fa-chevron-right" @click.prevent="nextPage()"></i>
        </button>
      </div>
    </div>
    <div v-else>
      <div class="text-center mt-5">-- keine Treffer --</div>
    </div>

  </div>
</template>

<style scoped>

button {
  border: none;
  background: none;
  cursor: pointer;
}
</style>